import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { ItemPayment } from 'actions/actionTypes';
import * as actions from 'actions/billing/itemPayment';

import {callItemPayment, callItemPaymentHistoryList} from 'network/apis/billing/itemPayment';

function* addItemPaymentRequestSaga() {
    try {
        const itemPayment = yield select(state => state.itemPayment);

        const response = yield call(callItemPayment, itemPayment.paymentInfoData);

        yield put(actions.addItemPaymentMethodSuccess(response.data));
    } catch(error) {
        yield put(actions.addItemPaymentMethodFailure(error.message));
    }
}

function* loadNoticeListRequestSaga() {
    try {
        const itemPayment = yield select(state => state.itemPayment);
        var data = {
            Page: itemPayment.searchFilter.page,
            PageSize: itemPayment.searchFilter.pageSize,
        };

        const response = yield call(callItemPaymentHistoryList, data);

        yield put(actions.loadItemPaymentHistoryListSuccess(response.data));
    } catch(error) {
        yield put(actions.loadItemPaymentHistoryListFailure(error.message));
    }
}



export default function* root() {
    yield all([
        takeLatest(ItemPayment.ADD_ITEM_PAYMENT_METHOD_REQUEST, addItemPaymentRequestSaga),
        takeLatest(ItemPayment.LOAD_ITEM_PAYMENT_HISTORY_LIST_REQUEST, loadNoticeListRequestSaga),
    ]);
}